import { useEffect, useState } from "react";
import React from "react";
import dropdownIcon from '../../../assets/icons/dropdown.svg';
import errorIcon from "../../../assets/icons/error.svg";
import { validateIdNumber, validateRequired, validatePhone, validateEmail } from "../../../services/validationFunctions";
import { Passenger } from "./PassengersDetails";


interface PassengerFormProps {
  index: number;
  data: Passenger;
  onChange: (index: number, key: string, value: string) => void;
  extraQuestions?: React.ReactNode, 
  onBlur: (index: number, key: string, validator: (value: string) => string) => void;
}

const PassengerForm = ({ index, data, onChange, onBlur, extraQuestions }: PassengerFormProps) => {
  const [expanded, setExpanded] = useState(false);
  const handleIdNumberBlur = () => {
    const validationResult = validateIdNumber(data.idNumber, data.idType);
    onBlur(index, "idNumber", () => validationResult);
  };

  useEffect(() => {
    // we check if it's the first passenger and if it doesn't have any data we expand it automatically
    if (index === 0 && data) setTimeout(() => { setExpanded(true) }, 300);
  }, [index, data])

  return (
    // arreglar width del container
    <div className="passenger-dropdown__container">
      <button
        className="passenger-dropdown__button"
        onClick={() => setExpanded(!expanded)}
      >
        <div className="passenger-dropdown__button-elements">
          <span>
            {data.fullName
              ? data.fullName
              : `Ingresar datos del pasajero #${index + 1}`}
          </span>
        </div>
        <div className={expanded ? "dropdown__icon dropdown__icon--expanded" : "dropdown__icon"}>
          <img src={dropdownIcon} alt="Dropdown" />
        </div>
      </button>
      <form className={`passenger-dropdown__form${expanded ? ' expanded' : ''}`}>
        <div
          className={`passenger-dropdown__form-row${data.errors.fullName ? " error" : ""
            }`}
        >
          <label htmlFor={`fullName${index}`}>Nombre completo</label>
          <input
            id={`fullName${index}`}
            type="text"
            placeholder="Ingresa tu nombre completo"
            value={data.fullName}
            onChange={(e) => onChange(index, "fullName", e.target.value)}
            onBlur={() => onBlur(index, "fullName", validateRequired)}
          />
          {data.errors.fullName && (
            <div className="error"><img src={errorIcon} alt="Error" />{data.errors.fullName}</div>
          )}
        </div>
        <div className="passenger-dropdown__form-row passenger-dropdown__form-grid">
          <div
            className={`${data.errors.phone ? " error" : ""
              }`}
          >
            <label htmlFor={`phone${index}`}>Teléfono</label>
            <input
              id={`phone${index}`}
              type="tel"
              placeholder="+5491165322334"
              value={typeof data.phone === 'string' ? data.phone : ''}
              onChange={(e) => onChange(index, "phone", e.target.value)}
              onBlur={() => onBlur(index, "phone", validatePhone)}
            />
            {data.errors.phone && <div className="error"><img src={errorIcon} alt="Error" />{data.errors.phone}</div>}
          </div>
          <div
            className={`${data.errors.email ? " error" : ""
              }`}
          >
            <label htmlFor={`email${index}`}>Correo electrónico</label>
            <input
              id={`email${index}`}
              type="email"
              placeholder="email@ejemplo.com"
              value={data.email}
              onChange={(e) => onChange(index, "email", e.target.value)}
              onBlur={() => onBlur(index, "email", validateEmail)}
            />
            {data.errors.email && <div className="error"><img src={errorIcon} alt="Error" />{data.errors.email}</div>}
          </div>
        </div>
        <div className="passenger-dropdown__form-row passenger-dropdown__form-grid">
          <div className={`${data.errors.dob ? " error" : ""}`}>
            <label htmlFor={`dob${index}`}>Fecha de nacimiento</label>
            <input
              id={`dob${index}`}
              type="date"
              value={typeof data.dob === 'string' ? data.dob : ''}
              onChange={(e) => onChange(index, "dob", e.target.value)}
              onBlur={() => onBlur(index, "dob", validateRequired)}
            />
            {data.errors.dob && <div className="error"><img src={errorIcon} alt="Error" />{data.errors.dob}</div>}
          </div>
          <div className={`${data.errors.nationality ? " error" : ""}`}>
            <label htmlFor={`nationality${index}`}>Nacionalidad</label>
            <input
              id={`nationality${index}`}
              type="text"
              placeholder="Nacionalidad"
              value={data.nationality}
              onChange={(e) => onChange(index, "nationality", e.target.value)}
              onBlur={() => onBlur(index, "nationality", validateRequired)}
            />
            {data.errors.nationality && (
              <div className="error"><img src={errorIcon} alt="Error" />{data.errors.nationality}</div>
            )}
          </div>
        </div>
        <div className="passenger-dropdown__form-row passenger-dropdown__form-grid">
          <div className={`${data.errors.idType ? " error" : ""}`}>
            <label htmlFor={`idType${index}`}>Tipo de documento</label>
            <select
              id={`idType${index}`}
              value={data.idType}
              onChange={(e) => onChange(index, "idType", e.target.value)}
              onBlur={() => onBlur(index, "idType", validateRequired)}
            >
              <option value="" disabled>Tipo de documento</option>
              <option value="passport">Passport</option>
              <option value="nationalId">DNI / CUIT</option>
            </select>
            {data.errors.idType && (
              <div className="error"><img src={errorIcon} alt="Error" />{data.errors.idType}</div>
            )}
          </div>
          <div className={`${data.errors.idNumber ? " error" : ""}`}>
            <label htmlFor={`idNumber${index}`}>Número de documento</label>
            <input
              id={`idNumber${index}`}
              type="text"
              placeholder="Ingresar número de documento"
              value={data.idNumber}
              onChange={(e) => onChange(index, "idNumber", e.target.value)}
              onBlur={handleIdNumberBlur}
            />
            {data.errors.idNumber && (
              <div className="error"><img src={errorIcon} alt="Error" />{data.errors.idNumber}</div>
            )}
          </div>
        </div>
        { extraQuestions && extraQuestions }
      </form>
    </div>
  );
};

export default PassengerForm;
